import { ReactNode } from 'react';

import OrganisationContext, { OrganisationContextValue } from './organisationDetailsContext';

const OrganisationProvider = ({
	value,
	children,
}: {
	value: OrganisationContextValue;
	children: ReactNode;
}) => {
	return <OrganisationContext value={value}>{children}</OrganisationContext>;
};

export default OrganisationProvider;
